<template>
  <div
    class="fixed w-full bg-white z-20 border-t border-gray-12"
    style="margin-top: 56px; box-shadow: 0 0 8px rgba(152, 163, 190, 0.3)"
  >
    <div
      class="flex items-center leading-4 px-8 sp-page-header-container"
      style="min-height: 56px"
    >
      <BaseIconButton @click="back()">
        <img src="@/assets/icons/Back2.svg" />
      </BaseIconButton>
      <div class="flex-1 sp-page-header-content">
        <div
          class="flex items-center sp-flex-direction-column sp-flex-align-start"
        >
          <div class="flex items-center">
            <div
              class="text-gray-92 font-semibold sp-buyer-company-name-margin sp-buyer-company-name-truncate"
              style="font-size: 20px; line-height: 30px"
            >
              {{ transaction.buyer_company_name }}
            </div>
          </div>
          <div class="flex flex-auto items-center justify-end">
            <CompTxSelectStatusLabel
              :transaction="transaction"
              :isCancelableRefuse="isCancelableRefuse"
              :isEditableApplyComment="isEditableApplyComment"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/utils.js';
import BaseIconButton from '@/components/BaseIconButton.vue';
import CompTxSelectStatusLabel from '@/views/tx/vue/parts/CompTxSelectStatusLabel';

export default {
  props: {
    transaction: {
      required: true,
    },
    txType: {
      required: true,
    },
    isCancelableRefuse: {
      type: Boolean,
    },
    isEditableApplyComment: {
      type: Boolean,
    },
  },
  components: {
    CompTxSelectStatusLabel,
    BaseIconButton,
  },
  setup() {
    const newNextDomain = process.env.VUE_APP_NEW_NEXT_DOMAIN;
    const back = () => {
      location.href = newNextDomain + '/tx';
    };
    return {
      utils,
      back,
    };
  },
};
</script>

<style lang="scss" scoped>
.right-enter-from,
.right-leave-to {
  transform: translateX(100vw);
}

.right-enter-active,
.right-leave-active {
  transition: transform 0.5s cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.sp-flex-direction-column {
  flex-direction: row;
}
.sp-page-header-content {
  margin-left: 2.5rem; // tailwindがもともとremを設定しているため形式を合わせる
}
.sp-buyer-company-name-margin {
  margin: 0.75rem; // tailwindがもともとremを設定しているため形式を合わせる
}

@media (max-width: 640px) {
  .sp-flex-direction-column {
    flex-direction: column;
  }
  .sp-flex-align-start {
    align-items: start;
  }
  .sp-page-header-container {
    padding: 8px 16px;
  }
  .sp-page-header-content {
    margin-left: 16px;
  }
  .sp-buyer-company-name-margin {
    margin: 0;
  }
  .sp-buyer-company-name-truncate {
    width: 272px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
